<template>
  <b-form :novalidate="allow_partial_save" @submit.prevent="onSubmit">
    <b-row v-for="(question, index) in filteredVisibleQuestions" :key="index"
           :style="hiddenQuestionSlugs.indexOf(question.slug) >= 0 && !show_hidden_questions ? 'display: none;' : ''">
      <b-col v-if="!question.is_hidden" class="mb-4">
        <form-input-question
          v-if="question.type == 'input'"
          :size="size"
          v-model="answers[question.slug]"
          :errors="errors[question.slug]"
          :question="question"
          :disabled="busy"
          :word-limit-active="question.options.word_limit_active"
          :word-limit="Number(question.options.word_limit)"
          @clear-error="onClearError"
        ></form-input-question>
        <form-number-question
          v-if="question.type == 'number'"
          :size="size"
          v-model="answers[question.slug]"
          :errors="errors[question.slug]"
          :question="question"
          :disabled="busy"
          @clear-error="onClearError"
        ></form-number-question>
        <form-date-question
          v-if="question.type == 'date'"
          :size="size"
          v-model="answers[question.slug]"
          :errors="errors[question.slug]"
          :question="question"
          :disabled="busy"
          @clear-error="onClearError"
        ></form-date-question>
        <form-date-selection-question
          v-if="question.type == 'date_selection'"
          :size="size"
          v-model="answers[question.slug]"
          :errors="errors[question.slug]"
          :question="question"
          :disabled="busy"
          @clear-error="onClearError"
        ></form-date-selection-question>
        <form-date-range-question
          v-if="question.type == 'date_range'"
          :organization="organization"
          :size="size"
          v-model="answers[question.slug]"
          :errors="errors[question.slug]"
          :question="question"
          :disabled="busy"
          @clear-error="onClearError"
        ></form-date-range-question>
        <form-date-range-selection-question
          v-if="question.type == 'date_range_selection'"
          :size="size"
          v-model="answers[question.slug]"
          :errors="errors[question.slug]"
          :question="question"
          :disabled="busy"
          @clear-error="onClearError"
        ></form-date-range-selection-question>
        <form-time-selection-question
          v-if="question.type == 'time_selection'"
          :size="size"
          v-model="answers[question.slug]"
          :errors="errors[question.slug]"
          :question="question"
          :disabled="busy"
          @clear-error="onClearError"
        ></form-time-selection-question>
        <form-select-question
          v-if="question.type == 'select'"
          :organization="organization"
          :size="size"
          v-model="answers[question.slug]"
          :errors="errors[question.slug]"
          :question="question"
          :disabled="busy"
          @clear-error="onClearError"
        ></form-select-question>
        <form-radios-question
          v-if="question.type == 'radios' || (question.type == 'radios_branch' && !question.options.checkbox)"
          :size="size"
          v-model="answers[question.slug]"
          :errors="errors[question.slug]"
          :question="question"
          :disabled="busy"
          @clear-error="onClearError"
        ></form-radios-question>
        <form-checkboxes-question
          v-if="question.type == 'checkboxes' || (question.type == 'radios_branch' && question.options.checkbox)"
          :size="size"
          v-model="answers[question.slug]"
          :errors="errors[question.slug]"
          :question="question"
          :disabled="busy"
          :organization="organization"
          @clear-error="onClearError"
        ></form-checkboxes-question>
        <form-acceptance-question
          v-if="question.type == 'acceptance'"
          :size="size"
          v-model="answers[question.slug]"
          :errors="errors[question.slug]"
          :question="question"
          :disabled="busy"
          @clear-error="onClearError"
        ></form-acceptance-question>
        <form-signature-question
          v-if="question.type == 'signature'"
          :size="size"
          v-model="answers[question.slug]"
          :errors="errors[question.slug]"
          :question="question"
          :disabled="busy"
          :button-color="buttonColor"
          @clear-error="onClearError"
        ></form-signature-question>
        <form-person-question
          v-if="isTypePerson(question.type)"
          :organization="organization"
          :size="size"
          v-model="answers[question.slug]"
          :errors="personErrors(question)"
          :question="maybeProcessPersonQuestion(question)"
          :lock-name-email="isPersonLocked(question)"
          :disabled="busy"
          :initial-value="question.type == 'account_owner' ? accountOwnerFromRecipient : null"
          propose-names
          :person-answers="personAnswers"
          @client="onClientChanged"
          @clear-error="onClearError"
        ></form-person-question>
        <form-children-question
          v-if="question.type == 'children'"
          :organization="organization"
          :size="size"
          v-model="answers[question.slug]"
          :errors="errors[question.slug]"
          :question="question"
          :disabled="busy"
          @clear-error="onClearError"
        ></form-children-question>
        <form-contacts-question
          v-if="question.type == 'contacts'"
          :organization="organization"
          :size="size"
          v-model="answers[question.slug]"
          :errors="errors[question.slug]"
          :question="question"
          :disabled="busy"
          @clear-error="onClearError"
        ></form-contacts-question>
        <form-media-question
          v-if="question.type == 'images' || question.type == 'videos'"
          :size="size"
          :media-collection="question.type"
          :url="url"
          v-model="answers[question.slug]"
          :errors="errors[question.slug]"
          :question="question"
          :disabled="busy"
          @busy="busy = $event"
        ></form-media-question>
        <form-text-block
          v-if="question.type == 'text_block'"
          :organization="organization"
          :size="size"
          v-model="answers[question.slug]"
          :errors="errors[question.slug]"
          :question="question"
          :disabled="busy"
          @clear-error="onClearError"
        ></form-text-block>
        <form-image-block
          v-if="question.type == 'image_block'"
          :organization="organization"
          :size="size"
          v-model="answers[question.slug]"
          :errors="errors[question.slug]"
          :question="question"
          :disabled="busy"
          @clear-error="onClearError"
        ></form-image-block>
        <form-notify-question
         v-if="question.type == 'notify'"
          :size="size"
          v-model="answers[question.slug]"
          :errors="errors[question.slug]"
          :question="question"
          :disabled="busy"
          @clear-error="onClearError"
        ></form-notify-question>
      </b-col>
    </b-row>
    <b-alert variant="secondary" :show="hiddenQuestionSlugs.length > 0 && !show_hidden_questions" class="mb-4">
      {{ trans('form_hidden_answered_questions') }}
      <b-button variant="outline-secondary" size="sm" class="ml-2 py-0" @click="show_hidden_questions = true">
        {{ trans('show') }}
      </b-button>
    </b-alert>
    <p v-if="busy">
      <i class="fa fa-fw fa-circle-notch fa-spin"></i>
      {{ trans('please_wait') }}
    </p>
    <p v-if="message" class="text-danger">
      {{ message }}
    </p>
    <b-row>
      <b-col v-if="showPrevious">
        <b-button variant="outline-secondary" :disabled="busy" @click="$emit('previous')">
          {{ previousButtonLabel }}
        </b-button>
      </b-col>
      <b-col :class="showPrevious ? 'text-right' : ''">
        <div v-if="canShowAllowPartialSave" class="d-inline-block mr-2">
          <b-form-checkbox v-model="allow_partial_save" switch class="danger text-danger">
            {{ trans('allow_partial_save') }}
            <small
              :title="trans('payment_form_allow_partial_save_about') + ' ' + trans('visible_only_administrators') + '.'"
              v-b-tooltip.hover>
              <i class="fa fa-fw fa-info-circle"></i>
            </small>
          </b-form-checkbox>
        </div>
        <b-button variant="branded" type="submit" :disabled="busy">
          {{ nextButtonLabel }}
        </b-button>
      </b-col>
    </b-row>
  </b-form>
</template>

<script>
import FormInputQuestion from './../form-questions/FormInputQuestion'
import FormNumberQuestion from './../form-questions/FormNumberQuestion'
import FormDateQuestion from './../form-questions/FormDateQuestion'
import FormDateRangeQuestion from './../form-questions/FormDateRangeQuestion'
import FormDateSelectionQuestion from './../form-questions/FormDateSelectionQuestion'
import FormDateRangeSelectionQuestion from './../form-questions/FormDateRangeSelectionQuestion'
import FormTimeSelectionQuestion from './../form-questions/FormTimeSelectionQuestion'
import FormSelectQuestion from './../form-questions/FormSelectQuestion'
import FormRadiosQuestion from './../form-questions/FormRadiosQuestion'
import FormCheckboxesQuestion from './../form-questions/FormCheckboxesQuestion'
import FormAcceptanceQuestion from './../form-questions/FormAcceptanceQuestion'
import FormSignatureQuestion from './../form-questions/FormSignatureQuestion'
import FormPersonQuestion from './../form-questions/FormPersonQuestion'
import FormChildrenQuestion from './../form-questions/FormChildrenQuestion'
import FormContactsQuestion from './../form-questions/FormContactsQuestion'
import FormMediaQuestion from './../form-questions/FormMediaQuestion'
import FormTextBlock from './../form-questions/FormTextBlock'
import FormImageBlock from './../form-questions/FormImageBlock'
import FormNotifyQuestion from './../form-questions/FormNotifyQuestion'

export default {
  props: {
    organization: Object,
    form: Object,
    recipient: Object,
    initialAnswers: Object,
    url: String,
    size: {
      type: String,
      default: 'md',
    },
    showPrevious: {
      type: Boolean,
      default: false,
    },
    forcePartialSave: {
      type: Boolean,
      default: false,
    },
    nextButtonLabel: {
      type: String,
      default: trans('next'),
    },
    previousButtonLabel: {
      type: String,
      default: trans('previous'),
    },
    invoice: Object, // Can be null
  },
  components: {
    FormInputQuestion,
    FormNumberQuestion,
    FormDateQuestion,
    FormDateRangeQuestion,
    FormDateRangeSelectionQuestion,
    FormSelectQuestion,
    FormDateSelectionQuestion,
    FormTimeSelectionQuestion,
    FormRadiosQuestion,
    FormCheckboxesQuestion,
    FormAcceptanceQuestion,
    FormSignatureQuestion,
    FormPersonQuestion,
    FormChildrenQuestion,
    FormContactsQuestion,
    FormMediaQuestion,
    FormTextBlock,
    FormImageBlock,
    FormNotifyQuestion
  },
  data() {
    return {
      trans: trans,
      moment: moment,
      numeral: numeral,
      errorFromAjax: _.errorFromAjax,
      busy: false,
      answers: {},
      message: null,
      errors: {},
      allow_partial_save: false,
      show_hidden_questions: false,
      questions: this.form?.form_questions || []
    }
  },
  computed: {
    canShowAllowPartialSave() {
      return !this.forcePartialSave &&
        this.organization.auth_user &&
        this.organization.auth_user.microsite_permissions.has_admin_panel
    },
    accountOwnerFromRecipient() {
      if (!this.recipient) return null
      let result = _.pick(this.recipient, ['id', 'first_name', 'last_name', 'name', 'email', 'mobile'])
      if (this.recipient.extra.account_owner) _.assign(result, this.recipient.extra.account_owner)
      if (!result.first_name && !!result.name) {
        let [full_name, first_name, last_name] = _.splitFullName(result.name)
        result.first_name = first_name
        result.last_name = last_name
      }
      if (this.recipient.extra.membership) {
        result.membership = this.recipient.extra.membership
      }
      return result
    },
    visibleQuestions() {
      if (this.canShowAllowPartialSave) return this.form.form_questions
      return _.reduce(this.form.form_questions, (questions, q) => {
        if ((!q.visibility || this.canShowAllowPartialSave)) questions.push(q)
        return questions
      }, [])
    },
    filteredVisibleQuestions() {
      return _.reduce(this.visibleQuestions, (questions, q) => {
        if (!_.includes(this.branchHiddenQuestionIds, q.id)) {
          questions.push(q)
        }
        return questions
      }, [])
    },
    personAnswers() {
      return _.reduce(this.answers || {}, (answers, a, slug) => {
        if (!a) return answers
        let q = _.find(this.form.form_questions, {slug: slug})
        if (!!q && ['account_owner', 'person'].indexOf(q.type) >= 0)
          answers.push(_.assign({question_id: q.id, type: q.type}, a))
        return answers
      }, [])
    },
    personQuestions() {
      return _.reduce(this.visibleQuestions, (questions, q) => {
        if (q.type == 'person') questions.push(q)
        return questions
      }, [])
    },
    invoicePersonQuestionIds() {
      if (!this.invoice) return []
      return _.reduce(this.invoice.invoice_items, (ids, ii) => {
        if (!!ii.form_question_id &&
          !!_.find(this.personQuestions, {id: ii.form_question_id}) &&
          ids.indexOf(ii.form_question_id) === -1)
          ids.push(ii.form_question_id)
        return ids
      }, [])
    },
    invoiceAnsweredQuestionIds() {
      if (!this.invoice) return []
      return _.reduce(this.invoice.invoice_items, (ids, ii) => {
        if (!!ii.form_answer_id &&
          !!ii.form_question_id &&
          ids.indexOf(ii.form_question_id) === -1)
          ids.push(ii.form_question_id)
        return ids
      }, [])
    },

    // For bookings with a logged in member, when all players are already chosen, no need to show the player questions
    isBookingFormWithPlayers() {
      return !!this.invoice &&
        this.personQuestions.length == 3 &&
        _.reduce(this.invoice.invoice_items, (has, ii) => {
          if (!!ii.package && !!ii.package.ask_for_players) has = true
          return has
        }, false)
    },
    hiddenQuestionSlugs() {
      if (!this.isBookingFormWithPlayers) return []

      let visiblePersonQuestionSlugs = _.map(this.personQuestions, 'slug')

      // Possibly hide player questions that are not needed
      if (visiblePersonQuestionSlugs.length > this.invoicePersonQuestionIds.length) {
        visiblePersonQuestionSlugs.pop()
      }
      if (visiblePersonQuestionSlugs.length > this.invoicePersonQuestionIds.length) {
        visiblePersonQuestionSlugs.pop()
      }
      if (visiblePersonQuestionSlugs.length > this.invoicePersonQuestionIds.length) {
        visiblePersonQuestionSlugs.pop()
      }

      // Keep ones that are required
      // Hence, the checkout form should only contain NOT required player questions
      // We will make them required here (see maybeProcessPersonQuestion)
      return _.reduce(this.personQuestions, (slugs, q) => {
        if (visiblePersonQuestionSlugs.indexOf(q.slug) === -1 && !q.required) slugs.push(q.slug)
        return slugs
      }, [])
    },
    branchHiddenQuestionIds() {
      return _.reduce(this.questions, (ids, q, i) => {
        if (q.type == 'radios_branch') {
          let answer = _.find(this.answers, (answer, slug) => slug == q.slug)
          _.each(q.options.values, (v, j) => {
            if (v != answer) {
              _.each(q.options.show_question_ids[j] || [], id => {
                if (ids.indexOf(id) === -1) ids.push(id)
              })
            }
          })
        }
        return ids
      }, [])
    },
  },
  watch: {
    initialAnswers() {
      this.hydrate()
    },
  },
  methods: {
    maybeProcessPersonQuestion(q) {
      if (this.isBookingFormWithPlayers &&
        this.hiddenQuestionSlugs.indexOf(q.slug) === -1) {
        return _.assign({}, q, {required: true})
      }
      return q
    },
    isTypePerson(type) {
      return ['person', 'account_owner', 'other_parent', 'child', 'company'].indexOf(type) >= 0
    },
    isPersonLocked(question) {
      return this.isTypePerson(question.type) && this.invoiceAnsweredQuestionIds.indexOf(question.id) >= 0 ||
        question.type == 'account_owner' && !!this.organization.connected_client
    },
    onClientChanged(client) {
      //if (!client) this.answers = {}
      this.$emit('client', client)
    },
    onClearError(attribute) {
      this.errors[attribute] = undefined
    },
    onSubmit(e) {
      this.busy = true
      this.message = null
      this.errors = {}
      const url = this.url || `/org/${this.organization.id}/form/${this.form.id}`
      axios.post(url,
        _.assign(
          {allow_partial_save: this.forcePartialSave || this.allow_partial_save},
          this.answers
        )
      )
        .then(response => {
          this.busy = false
          this.$emit('invoice', response.data)
        })
        .catch(error => {
          this.busy = false
          this.message = error &&
          error.response &&
          error.response.data &&
          error.response.data.message ?
            error.response.data.message :
            null
          // TODO: This should be translated in the back-end
          if (this.message == 'The given data was invalid.')
            this.message = trans('invalid_form_data')
          this.errors = error &&
          error.response &&
          error.response.data &&
          error.response.data.errors ?
            error.response.data.errors :
            {}
        })
    },
    personErrors(question) {
      return _.reduce(this.errors, (errors, error, key) => {
        if (key.indexOf(question.slug + '.') === 0) {
          errors[key.replace(question.slug + '.', '')] = error
        }
        return errors
      }, {})
    },
    hydrate() {
      let answers = {}
      _.each(this.form.form_questions, question => {
        answers[question.slug] = null
        if (question.type == 'checkboxes' ||
          question.type == 'images' ||
          question.type == 'videos') {
          answers[question.slug] = []
        }
        if (!!this.initialAnswers && this.initialAnswers[question.slug] !== undefined) {
          answers[question.slug] = _.cloneDeep(this.initialAnswers[question.slug])
        } else if (['number', 'input'].indexOf(question.type) >= 0 &&
          !!question.options.default) {
          answers[question.slug] = _.cloneDeep(question.options.default)
        }
      })
      this.answers = answers
    },
  },
  mounted() {
    window['form' + this.form.id] = this
    this.$nextTick(() => {
      this.hydrate()
    })
  },
}
</script>
